import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const signMethodService = {};

// sign method
signMethodService.listItems = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_code,
  bu_parent
) {
  return fetch({
    url: `${env.API_MSP}/sign-methods`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
      bu_code_relation: bu_code,
    },
  });
};

// Detail sign method
signMethodService.detailItems = function (id) {
  return fetch({
    url: `${env.API_MSP}/sign-methods/${id}`,
    method: "get",
  });
};

// Create sign method
signMethodService.createItems = function (data) {
  return fetch({
    url: `${env.API_MSP}/sign-methods`,
    method: "post",
    data,
  });
};

// Create list sign method
signMethodService.createListItems = function (data) {
  return fetch({
    url: `${env.API_MSP}/sign-methods/record`,
    method: "post",
    data: {
      items: data,
    },
  });
};

// Edit sign method
signMethodService.editItems = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/sign-methods/${id}`,
    method: "put",
    data,
  });
};

// Delete sign method
signMethodService.deleteItems = function (id) {
  return fetch({
    url: `${env.API_MSP}/sign-methods/${id}`,
    method: "delete",
  });
};

// listVats
signMethodService.listVats = function () {
  return fetch({
    url: `${env.API_MSP}/vats?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "tsuat,ltsuat,id",
      sort: "tsuat",
    },
  });
};

// listVats
signMethodService.listAllProduct = function () {
  return fetch({
    url: `${env.API_MSP}/sign-methods`,
    method: "get",
    params: {
      page: -1,
      fields: "code,id_vat,name,price,unit,id,vat_text",
      sort: "code",
      "filter[record_status]": "O",
    },
  });
};

export default signMethodService;
